import { render, staticRenderFns } from "./related-work-groups.vue?vue&type=template&id=377be30f&scoped=true"
import script from "./related-work-groups.vue?vue&type=script&lang=js"
export * from "./related-work-groups.vue?vue&type=script&lang=js"
import style0 from "./related-work-groups.vue?vue&type=style&index=0&id=377be30f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377be30f",
  null
  
)

export default component.exports